
import { ConfigProvider } from './AppContext';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Play from './pages/Play';
import { Toaster } from 'react-hot-toast';
import { createMemoryHistory } from 'history';
import { theme } from './styles/theme';
import { AppContainer, GlobalStyles } from './styles/GlobalStyles';
import Respond from './pages/Respond';
import Edit from './pages/Edit';
import Review from './pages/Review';
import Publish from './pages/Publish';
import Qcast from './pages/Qcast';

import { AppConfig } from './types/data';
import { ASRProvider } from './context/ASRContext';
import { useEffect } from 'react';
import Responses from './pages/Responses';

const App=()=> {
  const history = createMemoryHistory();
  const config: AppConfig={
    apiKey: "DU1PJCkJmUfpAifrelyPiptN47ILEHthg82fUkUKLdSTF5yUKNOKoMgouV-pKd7bOZcXKxaDMfscaILVNPIjUg",
    theme: "dark",
    fontSize: "16px"
  }

  useEffect(() => {
    // Function to update the viewport height
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
  
    // Set the initial value
    setVH();
    
    // Update on resize and orientation change
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);
    
    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
    };
  }, []);
  return (
    <ConfigProvider config={config}>
        <AppContainer>
          <GlobalStyles />
          <Router>
            <Routes>
              <Route path="/" element={<Play />} />
              <Route path="/responses" element={<Responses />} />
              <Route path="/:code" element={<Play />} />
              <Route path="/qcast" element={<Qcast />}>
                <Route index element={<Navigate to="respond" replace />} />
                <Route path="/qcast/respond" element={<Respond />} />
                <Route path="/qcast/edit" element={<Edit />} />
                <Route path="/qcast/review" element={<Review />} />
              </Route>
              <Route path="/publish" element={<Publish />} />
              <Route path="*" element={<> Page not found</>} />
            </Routes>
          </Router>  
          <Toaster />
        </AppContainer>
    </ConfigProvider>
  );
}

export default App;
